import { buildApiUrl } from "../config/env";

const parseJsonSafe = async (response) => response.json().catch(() => null);

const toErrorMessage = (payload, fallback) => {
  if (typeof payload === "string" && payload.trim()) return payload;
  if (payload?.detail) {
    if (typeof payload.detail === "string") return payload.detail;
    if (Array.isArray(payload.detail)) return payload.detail.join("\n");
  }
  if (payload?.message) return payload.message;
  return fallback;
};

const requestJson = async (
  path,
  options = {},
  fallbackError = "Request failed",
) => {
  const response = await fetch(buildApiUrl(path), options);
  const payload = await parseJsonSafe(response);

  if (!response.ok) {
    const error = new Error(toErrorMessage(payload, fallbackError));
    error.status = response.status;
    error.payload = payload;
    throw error;
  }

  return payload;
};

export const getNamingRules = () =>
  requestJson(
    "naming-rules/",
    { method: "GET" },
    "Failed to load naming rules",
  );

export const getNamingDocumentTypes = () =>
  requestJson(
    "naming-rules/document-types",
    { method: "GET" },
    "Failed to load naming document types",
  );

export const createNamingRule = (body) =>
  requestJson(
    "naming-rules/",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    },
    "Failed to create naming rule",
  );

export const updateNamingRule = (ruleId, body) =>
  requestJson(
    `naming-rules/${ruleId}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    },
    "Failed to update naming rule",
  );

export const deleteNamingRule = (ruleId) =>
  requestJson(
    `naming-rules/${ruleId}`,
    { method: "DELETE" },
    "Failed to delete naming rule",
  );

export const activateNamingRule = (ruleId) =>
  requestJson(
    `naming-rules/${ruleId}/activate`,
    { method: "PATCH" },
    "Failed to activate naming rule",
  );

export const deactivateNamingRule = (ruleId) =>
  requestJson(
    `naming-rules/${ruleId}/deactivate`,
    { method: "PATCH" },
    "Failed to deactivate naming rule",
  );

export const patchSessionMetadata = (sessionId, body) =>
  requestJson(
    `sessions/${sessionId}/metadata`,
    {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    },
    "Failed to update session metadata",
  );

export const previewSessionNaming = (sessionId) =>
  requestJson(
    `sessions/${sessionId}/naming/preview`,
    { method: "GET" },
    "Failed to preview naming",
  );

export const finalizeSessionNaming = (sessionId) =>
  requestJson(
    `sessions/${sessionId}/naming/finalize`,
    { method: "POST" },
    "Failed to finalize naming",
  );
